import { useEffect } from 'react';

// we use this hook to send screen events when the component mounts.
// we don't need to pass dependencies because we only want to send the event once.
// It will send the event by default, but if you want to control when to send the event, you can pass shouldSendEvent as false.

interface Options {
  shouldSendEvent?: boolean;
}

export const useSendScreenEventEffect = (
  eventFunction: () => void,
  options?: Options,
) => {
  const { shouldSendEvent = true } = options ?? {};

  useEffect(() => {
    if (shouldSendEvent) {
      eventFunction();
    }
  }, []);
};

export default useSendScreenEventEffect;
